var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"height":"100vhs","src":"http://103.4.145.253:8001/show-pdfjs?file=e-book/Atlas%20of%20Human%20Anatomy%20(%20PDFDrive%20)_1625393318.pdf"}})}
var staticRenderFns = []

export { render, staticRenderFns }